import React from 'react';
import { withStyles } from 'tss-react/mui';
import { authenticationService } from './services/auth_service';
import { Redirect } from 'react-router-dom';



const useStyles = (theme, props) => ({
    paper: {
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%'

    },

    grid: {
        margin: theme.spacing(3)
    },

});


class Callback extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      message: '',
      accept_terms: false,
      loginOk: false,
      loginFail: false,
    }
  }
    componentDidMount(){
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const govState = params.get('state');

                    if (!this.state.loginOk ){
                        this.tryLogin(code, govState)
                    }
    }

    tryLogin = (code, govState) =>{
        authenticationService.logingovbr(code, govState)
        .then(result =>{
            if (result.status === 200){
                this.setState({loginOk: true});
            }
        }).catch((e)=>{
            if (e.response){
                    let msg = "Houve um erro na conexão com o sistema. Tente novamente mais tarde."
                    if (e.response.status >= 500) {
                        this.setState({message: msg, openClose: true });
                        alert(msg)
                        window.location.href = e.response.data.logout_url

                    } else if (e.response.status === 404) {
                    msg = e.response.data?.msg || "CPF da mãe não encontrado. Por favor, entre em contato com o local de coleta";
                    this.setState({message: msg, openClose: true, loginFail: true})
                    alert(msg) 
                    window.location.href = e.response.data.logout_url
                    } else if (e.response.status === 403){ //usuário BRONZE
                        msg = "É necessário possuir conta gov.br nível prata ou ouro para utilizar este serviço";
                        this.setState({message: msg, openClose: true, loginFail: true})
                        alert(msg);
                        window.location.href = e.response.data.upgrade_url
                    }else if (e.response.status === 401){
                        msg = "O nome recebido pelo GOV-BR é diferente do cadastrado. Entre em contato com o local de coleta";
                        this.setState({message: msg, openClose: true, loginFail: true})
                        alert(msg) 
                        window.location.href = e.response.data.logout_url
                    } else {
                    this.setState({message: msg, openClose: true})
                        window.location.href = e.response.data.logout_url
                    }
                console.error(e.response.status ,e.response.data.detail) // para debugar no desenvolvimento
            } else{
                    let msg = "Houve um erro na conexão com o sistema. Tente novamente mais tarde."
                        this.setState({message: msg, openClose: true });
                        alert(msg)
                        window.location.href = '/'
            }
        })
    }

    render(){
            if(this.state.loginOk){
                return(<Redirect to={{pathname: '/Familia'}}/>)
            }
        return(
            <> 
            </>
        );
    }

}



export default withStyles(Callback, useStyles);
// export default Family

